export const SET_PATIENTS = 'SET_PATIENTS';

export const SET_NON_OVERREAD_PATIENTS = 'SET_NON_OVERREAD_PATIENTS';

export const SET_NON_ACCEPTED_PATIENTS = 'SET_NON_ACCEPTED_PATIENTS';

export const CLEAR_PATIENTS = 'CLEAR_PATIENTS';